import React from 'react';
import { Switch, Route, Redirect, withRouter  } from 'react-router-dom';

import axios from 'axios';
import apiPath from 'apiPath';

import PermissionSplash from 'components/PermissionSplash';
import AddProgram from './AddProgram';
import EditProgram from './EditProgram';
import DeleteProgram from './DeleteProgram';
import ViewPrograms from './ViewPrograms';
import PreviewProgram from './PreviewProgram';

class FieldAdmin extends React.Component {

	checkAdminLoggedIn(){
		axios.get(apiPath + '/getAdminLoggedIn', { withCredentials: true }).then(result => {
			//do nothing
		}).catch(error => {
			this.props.history.push('/');
		});
	}

	componentDidMount(){
		this.checkAdminLoggedIn();
	}
	render() {
		let routeProps = this.props;
		//console.log("props: " + JSON.stringify(routeProps));
		if (this.props.variant === 'admin') {
				return (
					<Switch>
						<Route path="/portal/fieldadmin" exact render={() => <ViewPrograms {...routeProps} />} />
						<Route path="/portal/fieldadmin/View Programs" render={() => <ViewPrograms {...routeProps} />} />
						<Route path="/portal/fieldadmin/New Program" render={() => <AddProgram {...routeProps} />} />
						<Route path="/portal/fieldadmin/Edit Program" render={() => <EditProgram {...routeProps} />} />
						<Route path="/portal/fieldadmin/Delete Program" render={() => <DeleteProgram {...routeProps} />} />
						<Route path="/portal/fieldadmin/preview/:voyageid/:programcode" exact render={(matchprops) => <PreviewProgram {...routeProps} {...matchprops} />} />
					</Switch>
				);
		} else {
			return (
				<PermissionSplash />
			);
		}
	}
}
export default withRouter(FieldAdmin);


// WEBPACK FOOTER //
// ./portal-components/Portal/FieldAdmin/index.jsx